export default import.meta.ROLLUP_FILE_URL_al0tn7aF75EcLyOlE$y7KQ